import { useTranslation } from 'react-i18next';

import { Control, FormCard } from '../../../../components';
import { CARD_CATEGORIES } from '../../../../shared/cardConfig/constants';
import { COMPANY_FIELDS } from '../../../../shared/fieldConfig/constants';
import { VALIDATION } from '../../../../utils/validation';
import type { CardField, CardFieldComponent, CardFieldProps, CardStore } from '../../types';

const category = CARD_CATEGORIES.company;

interface CompanyCardProps {
  isReview?: boolean;
  fields: CardField[];
  store?: CardStore;
}

function TradeDbaName({ isReview, store: { editMode: { company } = {} } = {}, t, required }: CardFieldProps) {
  const field = 'tradeDbaName';
  const name = `${category}.${field}`;
  const config = {
    name,
    category,
    field,
    required,
    label: t(`company.${category}.${field}.label`),
    validations: [{ type: VALIDATION.maxCharacters, param: 35 }],
    placeholder: t(`company.${category}.${field}.placeholder`),
    disabled: isReview && !company
  };

  return <Control {...config} />;
}

function LegalName({ isReview, store: { editMode: { company } = {} } = {}, t }: CardFieldProps) {
  const field = 'legalName';
  const name = `${category}.${field}`;
  const config = {
    name,
    category,
    field,
    label: t(`company.${category}.${field}.label`),
    validations: [{ type: VALIDATION.maxCharacters, param: 105 }],
    required: true,
    placeholder: t(`company.${category}.${field}.placeholder`),
    disabled: isReview && !company
  };

  return <Control {...config} />;
}

function ParentCompany({ isReview, t, required }: CardFieldProps) {
  const field = 'parentCompany';
  const name = `${category}.${field}`;
  const config = {
    name,
    category,
    field,
    required,
    label: t(`company.${category}.${field}.label`),
    placeholder: t(`company.${category}.${field}.placeholder`),
    disabled: isReview
  };

  return <Control {...config} />;
}

function CompanyCard({ isReview, fields, store }: CompanyCardProps) {
  const { t } = useTranslation();

  const cardProps = {
    cardId: category,
    title: t('company.company.title'),
    subtitle: '',
    image: '/food/onboarding/assets/Company_About_Company.svg',
    isReview,
    t
  };

  const controlMap: Record<string, CardFieldComponent> = {
    [COMPANY_FIELDS.tradeDbaName]: TradeDbaName,
    [COMPANY_FIELDS.legalName]: LegalName,
    [COMPANY_FIELDS.parentCompany]: ParentCompany
  };

  return (
    <FormCard {...cardProps}>
      {fields.map(({ key, ...fieldProps }: CardField) => {
        const Component = controlMap[key];
        return <Component t={t} isReview={isReview} store={store} {...fieldProps} key={key} />;
      })}
    </FormCard>
  );
}

export default CompanyCard;
